import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  key: 0,
  class: "space-y-4"
}
const _hoisted_3 = { class: "flex justify-between items-center" }
const _hoisted_4 = { class: "text-md font-semibold" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-600 mt-1"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "p-4 text-center bg-gray-50 border rounded"
}

import { ref } from "vue";
import { useEquipment } from "@/composables/tasks/useEquipment";
import { useEquipmentForm } from "@/composables/tasks/useEquipmentForm";
import EquipmentAddForm from "./Forms/EquipmentAddForm.vue";

// ===================================================================
// State
// ===================================================================

export default /*@__PURE__*/_defineComponent({
  __name: 'EquipmentTemplates',
  setup(__props) {

const showAddForm = ref(false);
const selectedTemplateId = ref<string | number | null>(null);

// ===================================================================
// Composables
// ===================================================================
// Equipment operations
const { getAvailableEquipmentTypes } = useEquipment();

// Equipment form
const {
  initAddForm,
  cancelForm,
} = useEquipmentForm();

// ===================================================================
// Actions
// ===================================================================
// Start adding a new configuration
const startAddingConfig = (typeId: string | number) => {
  selectedTemplateId.value = typeId;
  initAddForm(typeId);
  showAddForm.value = true;
};

// Handle form cancellation
const handleCancel = () => {
  cancelForm();
  showAddForm.value = false;
  selectedTemplateId.value = null;
};

// Handle successful save
const handleSaved = () => {
  showAddForm.value = false;
  selectedTemplateId.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (showAddForm.value)
      ? (_openBlock(), _createBlock(EquipmentAddForm, {
          key: 0,
          onCancel: handleCancel,
          onSaved: handleSaved
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(getAvailableEquipmentTypes) && _unref(getAvailableEquipmentTypes).length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "text-lg font-semibold" }, "Available Equipment Types", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAvailableEquipmentTypes), (type) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: type.id,
                    class: "border rounded p-4 bg-white"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_4, _toDisplayString(type.name), 1),
                        (type.description)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(type.description), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (startAddingConfig(type.id)),
                        class: "bg-primary text-white px-3 py-1 rounded text-sm"
                      }, " Add Configuration ", 8, _hoisted_6)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[1] || (_cache[1] = [
                _createElementVNode("p", { class: "text-gray-500" }, "All available equipment types have been configured.", -1)
              ])))
        ]))
  ]))
}
}

})